import { render } from "./step-buy-contract-and-notary-appointment.vue?vue&type=template&id=19305edd"
import script from "./step-buy-contract-and-notary-appointment.vue?vue&type=script&lang=ts"
export * from "./step-buy-contract-and-notary-appointment.vue?vue&type=script&lang=ts"
script.render = render

export default script